﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as nouislider from 'nouislider';
import * as FilePond from 'filepond';

import FilePondPluginFileEncode from '../../plugins/filepond-plugin-file-encode';
import FilePondPluginImageCrop from '../../plugins/filepond-plugin-image-crop';
import FilePondPluginImageResize from '../../plugins/filepond-plugin-image-resize';
import FilePondPluginImageTransform from '../../plugins/filepond-plugin-image-transform';
import FilePondPluginImagePreview from '../../plugins/filepond-plugin-image-preview';
import FilePondPluginImageEdit from '../../plugins/filepond-plugin-image-edit';

import * as plugins_jquery_fontselect from '../../plugins/jquery.fontselect'


import tpl_customWebpageEditItemRightContent from './tpl/customWebpageEditItemRightContent.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_DialogBox from '../../../lib/views/dialogBox/dialogBox';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import View_DialogPaintStrap from '../dialogPaintStrap/dialogPaintStrap';
import View_DialogPreviewWebpage from '../dialogPreview/dialogPreviewWebpage';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import * as Entities_Empty from '../../../lib/entities/empty';
import * as Entities_Memory_Position from '../../entities/memoryposition';

import * as Entities_customWebpageItem from '../../entities/customWebpageItem';
import * as Entities_CustomWebpageItem from '../../entities/customWebpageItem';
import * as Entities_CustomBuilder from '../../entities/customBuilder';

import View_CustomWebpageEditItemList from './customWebpageEditItemList';
import View_CustomWebpageEditItemListTop from './customWebpageEditItemListTop';
import View_CustomWebpageEditItemListBottom from './customWebpageEditItemListBottom';

import View_GridMenu from './setting/gridMenu';
import View_MenuSingle from './setting/menuSingle';


import config from '../../../common/config';
import Help from '../../helper/help';

import helper_image from '../../helper/image';

export default View_LayoutError.extend({
    className: 'row',
    getTemplate: function () {
        return tpl_customWebpageEditItemRightContent({ model: this.model.toJSON() });
    },
    regions: {
        customWebpageEditItemListTop: "#customWebpageEditItemListTop",
        customWebpageEditItemList: "#customWebpageEditItemList",
        customWebpageEditItemListBottom: "#customWebpageEditItemListBottom",
    },
    onBeforeShow: function () {
        var self = this;

        this.customWebpageEditItemListTop.show(new View_CustomWebpageEditItemListTop({ collection: this.collection, app: this.app, childViewContainer: '#customWebpageEditItemListTop' }));
        this.customWebpageEditItemList.show(new View_CustomWebpageEditItemList({ collection: this.collection, app: this.app, childViewContainer: '#customWebpageEditItemList' }));
        this.customWebpageEditItemListBottom.show(new View_CustomWebpageEditItemListBottom({ collection: this.collection, app: this.app, childViewContainer: '#customWebpageEditItemListBottom' }));
    },
    initialize: function () {
        this.app = this.options.app;
        this.localSetting = new Entities_Empty.Model();

        var userChannel = Backbone.Radio.channel('app');
        var self = this;

        this.listenTo(this.model, 'change', function () {
            //userChannel.trigger('customWebpageEditItemTopbar:iconSave');
            //userChannel.trigger('customWebpageEditItemRightContent:setFont', true);

            userChannel.trigger('customWebpageEditItemRightContent:setModel',  this.model);
            userChannel.trigger('customWebpageEditItemRightContent:setFont', this.model);
            userChannel.trigger('customWebpageEditItemRightContent:setBk', this.model);
        });

        this.setHasChanged(false);
    },
    help: function () {
        Help.help(this, true, 'customWebpageEditItemTopbar');
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        this.btnSubmit(null, false, true, callback, false);
    },
    cancelHasChanged: function () {
    },
    modelHasChanged: function () {
        var changes = false;
        this.setHasChanged(changes);
    },
    ui: {
        'customWebpageEditItemRightContent_filePond': '#customWebpageEditItemRightContent_filePond',
        'col_01': '#col_01',
        'col_02': '#col_02',
        'col_03': '#col_03',
        'col_04': '#col_04',
        'col_05': '#col_05',
        'col_06': '#col_06',
        'col_07': '#col_07',
        'col_08': '#col_08',
        'col_09': '#col_09',
        'col_10': '#col_10',
        'col_11': '#col_11',
        'col_12': '#col_12',

        'customWebpageEditItemRightContent_formgroup_Font1_ColorTheme': '#customWebpageEditItemRightContent_formgroup_Font1_ColorTheme',
        'customWebpageEditItemRightContent_formgroup_Font1_ColorSelect': '#customWebpageEditItemRightContent_formgroup_Font1_ColorSelect',
        'customWebpageEditItemRightContent_formgroup_Font2_ColorTheme': '#customWebpageEditItemRightContent_formgroup_Font2_ColorTheme',
        'customWebpageEditItemRightContent_formgroup_Font2_ColorSelect': '#customWebpageEditItemRightContent_formgroup_Font2_ColorSelect',

        'customWebpageEditItemRightContent_select_Font1_FontType': '#customWebpageEditItemRightContent_select_Font1_FontType',
        'customWebpageEditItemRightContent_select_Font2_FontType': '#customWebpageEditItemRightContent_select_Font2_FontType',
        'customWebpageEditItemRightContent_select_Font1_ColorType': '#customWebpageEditItemRightContent_select_Font1_ColorType',
        'customWebpageEditItemRightContent_select_Font2_ColorType': '#customWebpageEditItemRightContent_select_Font2_ColorType',
        

        'customWebpageEditItemRightContent_select_AppFrame_BackGroundType': '#customWebpageEditItemRightContent_select_AppFrame_BackGroundType',
        'customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_BackGroundColorApp': '#customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_BackGroundColorApp',
        'customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_BackGroundColor': '#customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_BackGroundColor',
        'customWebpageEditItemRightContent_select_AppFrame_ForeGroundType': '#customWebpageEditItemRightContent_select_AppFrame_ForeGroundType',
        'customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_ForeGroundColorApp': '#customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_ForeGroundColorApp',
        'customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_ForeGroundColor': '#customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_ForeGroundColor',

        'customWebpageEditItemRightContent_select_BackGroundColorType': '#customWebpageEditItemRightContent_select_BackGroundColorType',
        'customWebpageEditItemRightContent_ColorPickerSliders_BackGroundColorApp': '#customWebpageEditItemRightContent_ColorPickerSliders_BackGroundColorApp',
        'customWebpageEditItemRightContent_ColorPickerSliders_BackGroundColor': '#customWebpageEditItemRightContent_ColorPickerSliders_BackGroundColor',

        'customWebpageEditItemRightContent_select_MenuColorApp_FontType': '#customWebpageEditItemRightContent_select_MenuColorApp_FontType',
        
        'customWebpageEditItemRightContent_select_MenuColorApp_BackGroundType': '#customWebpageEditItemRightContent_select_MenuColorApp_BackGroundType',
        'customWebpageEditItemRightContent_select_MenuColorApp_ForeGroundType': '#customWebpageEditItemRightContent_select_MenuColorApp_ForeGroundType',

        'customWebpageEditItemRightContent_formgroup_MenuColorApp_Font': '#customWebpageEditItemRightContent_formgroup_MenuColorApp_Font',
        'customWebpageEditItemRightContent_dropDown_MenuColorApp_Font': '#customWebpageEditItemRightContent_dropDown_MenuColorApp_Font',
        'customWebpageEditItemRightContent_formgroup_MenuColor_Font': '#customWebpageEditItemRightContent_formgroup_MenuColor_Font',
        'customWebpageEditItemRightContent_dropDown_MenuColor_Font': '#customWebpageEditItemRightContent_dropDown_MenuColor_Font',
        
        //'customWebpageEditItemRightContent_btnImage': '#customWebpageEditItemRightContent_btnImage',
        //'customWebpageEditItemRightContent_inputImage': '#customWebpageEditItemRightContent_inputImage',
        'customWebpageEditItemRightContent_image_background': '#customWebpageEditItemRightContent_image_background',
        'customWebpageEditItemRightContent_dropDown_backGroundImagePosition': '#customWebpageEditItemRightContent_dropDown_backGroundImagePosition',
        'customWebpageEditItemRightContent_btnDeleteImage': '#customWebpageEditItemRightContent_btnDeleteImage',
        'customWebpageEditItemRightContent_ColorPickerSliders_MenuColor_BackGround': '#customWebpageEditItemRightContent_ColorPickerSliders_MenuColor_BackGround',
        'customWebpageEditItemRightContent_ColorPickerSliders_MenuColorApp_BackGround': '#customWebpageEditItemRightContent_ColorPickerSliders_MenuColorApp_BackGround',
        'customWebpageEditItemRightContent_ColorPickerSliders_MenuColor_ForeGround': '#customWebpageEditItemRightContent_ColorPickerSliders_MenuColor_ForeGround',
        'customWebpageEditItemRightContent_ColorPickerSliders_MenuColorApp_ForeGround': '#customWebpageEditItemRightContent_ColorPickerSliders_MenuColorApp_ForeGround',
        'customWebpageEditItemRightContent_btnClearBGColor': '#customWebpageEditItemRightContent_btnClearBGColor',
        'customWebpageEditItemRightContent_inputImage': '#customWebpageEditItemRightContent_inputImage',
        'customWebpageEditItemRightContent_dropDown_Font1_Select': '#customWebpageEditItemRightContent_dropDown_Font1_Select',
        'customWebpageEditItemRightContent_dropDown_Font1_Theme': '#customWebpageEditItemRightContent_dropDown_Font1_Theme',
        'customWebpageEditItemRightContent_formgroup_Font1_Select': '#customWebpageEditItemRightContent_formgroup_Font1_Select',
        'customWebpageEditItemRightContent_formgroup_Font1_Theme': '#customWebpageEditItemRightContent_formgroup_Font1_Theme',
        'customWebpageEditItemRightContent_ColorPickerSliders_Font1_ColorSelect': '#customWebpageEditItemRightContent_ColorPickerSliders_Font1_ColorSelect',
        'customWebpageEditItemRightContent_ColorPickerSliders_Font1_ColorTheme': '#customWebpageEditItemRightContent_ColorPickerSliders_Font1_ColorTheme',
        'customWebpageEditItemRightContent_dropDown_Font_Size1': '#customWebpageEditItemRightContent_dropDown_Font_Size1',
        'customWebpageEditItemRightContent_dropDown_Font_LineHeight1': '#customWebpageEditItemRightContent_dropDown_Font_LineHeight1',
        'customWebpageEditItemRightContent_dropDown_Font2_Select': '#customWebpageEditItemRightContent_dropDown_Font2_Select',
        'customWebpageEditItemRightContent_dropDown_Font2_Theme': '#customWebpageEditItemRightContent_dropDown_Font2_Theme',
        'customWebpageEditItemRightContent_formgroup_Font2_Select': '#customWebpageEditItemRightContent_formgroup_Font2_Select',
        'customWebpageEditItemRightContent_formgroup_Font2_Theme': '#customWebpageEditItemRightContent_formgroup_Font2_Theme',
        'customWebpageEditItemRightContent_dropDown_Font_Style1': '#customWebpageEditItemRightContent_dropDown_Font_Style1',
        'customWebpageEditItemRightContent_ColorPickerSliders_Font2_ColorSelect': '#customWebpageEditItemRightContent_ColorPickerSliders_Font2_ColorSelect',
        'customWebpageEditItemRightContent_ColorPickerSliders_Font2_ColorTheme': '#customWebpageEditItemRightContent_ColorPickerSliders_Font2_ColorTheme',
        'customWebpageEditItemRightContent_dropDown_Font_Size2': '#customWebpageEditItemRightContent_dropDown_Font_Size2',
        'customWebpageEditItemRightContent_dropDown_Font_Style2': '#customWebpageEditItemRightContent_dropDown_Font_Style2',
        'customWebpageEditItemRightContent_dropDown_Font_LineHeight2': '#customWebpageEditItemRightContent_dropDown_Font_LineHeight2',
        'customWebpageEditItemRightContent_dropDown_Font3': '#customWebpageEditItemRightContent_dropDown_Font3',
        'customWebpageEditItemRightContent_ColorPickerSliders_Font3_Color': '#customWebpageEditItemRightContent_ColorPickerSliders_Font3_Color',
        'customWebpageEditItemRightContent_dropDown_Font_Size3': '#customWebpageEditItemRightContent_dropDown_Font_Size3',
        'customWebpageEditItemRightContent_dropDown_Font_Style3': '#customWebpageEditItemRightContent_dropDown_Font_Style3',
        'customWebpageEditItemRightContent_dropDown_Font_LineHeight3': '#customWebpageEditItemRightContent_dropDown_Font_LineHeight3',
        'customWebpageEditItemRightContent_checkbox_EnableWindowPage': '#customWebpageEditItemRightContent_checkbox_EnableWindowPage',

        'demoBasic': '#demoBasic',
        'font1': '#font1'
    },
    events: {
        'click @ui.col_01': 'col_01_click',
        'click @ui.col_02': 'col_02_click',
        'click @ui.col_03': 'col_03_click',
        'click @ui.col_04': 'col_04_click',
        'click @ui.col_05': 'col_05_click',
        'click @ui.col_06': 'col_06_click',
        'click @ui.col_07': 'col_07_click',
        'click @ui.col_08': 'col_08_click',
        'click @ui.col_09': 'col_09_click',
        'click @ui.col_10': 'col_10_click',
        'click @ui.col_11': 'col_11_click',
        'click @ui.col_12': 'col_12_click',

        'colorpickerChange @ui.customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_BackGroundColor': 'colorChange_AppFrame_BackGroundColor',
        'colorpickerChange @ui.customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_ForeGroundColor': 'colorChange_AppFrame_ForeGroundColor',

        'colorpickerChange @ui.customWebpageEditItemRightContent_ColorPickerSliders_BackGroundColor': 'colorChange_BackGroundColor',

        'colorpickerChange @ui.customWebpageEditItemRightContent_ColorPickerSliders_MenuColor_BackGround': 'colorChange_MenuColor_BackGround',
        'colorpickerChange @ui.customWebpageEditItemRightContent_ColorPickerSliders_MenuColor_ForeGround': 'colorChange_MenuColor_ForeGround',

        'colorpickerChange @ui.customWebpageEditItemRightContent_ColorPickerSliders_MenuColor': 'colorChange_MenuColor',
        'colorpickerChange @ui.customWebpageEditItemRightContent_ColorPickerSliders_GridColor': 'colorChange_GridColor',

        //'change @ui.customWebpageEditItemRightContent_btnImage': 'btnImageChange',
        //'click @ui.customWebpageEditItemRightContent_btnDeleteImage': 'btnImageDelete',
        'change @ui.customWebpageEditItemRightContent_select_BackGroundColorType': 'modifyRest',

        'change @ui.customWebpageEditItemRightContent_select_MenuColorApp_BackGroundType': 'modifyRest',
        'change @ui.customWebpageEditItemRightContent_select_MenuColorApp_ForeGroundType': 'modifyRest',
        'change @ui.customWebpageEditItemRightContent_select_AppFrame_BackGroundType': 'modifyRest',
        'change @ui.customWebpageEditItemRightContent_select_AppFrame_ForeGroundType': 'modifyRest',

        'colorpickerChange @ui.customWebpageEditItemRightContent_ColorPickerSliders_Font1_ColorSelect': 'colorChange_Font1ColorSelect',
        'colorpickerChange @ui.customWebpageEditItemRightContent_ColorPickerSliders_Font2_ColorSelect': 'colorChange_Font2ColorSelect',
        'change @ui.customWebpageEditItemRightContent_dropDown_Font_Size1': 'modifyRest',
        'change @ui.customWebpageEditItemRightContent_dropDown_Font_Size2': 'modifyRest',
        'change @ui.customWebpageEditItemRightContent_dropDown_Font_LineHeight1': 'modifyRest',
        'change @ui.customWebpageEditItemRightContent_dropDown_Font_LineHeight2': 'modifyRest',
        'change @ui.customWebpageEditItemRightContent_dropDown_Font_Style1': 'modifyRest',
        'change @ui.customWebpageEditItemRightContent_dropDown_Font_Style2': 'modifyRest',
        'change @ui.customWebpageEditItemRightContent_checkbox_EnableWindowPage': 'modifyRest',
        'change @ui.customWebpageEditItemRightContent_dropDown_backGroundImagePosition': 'modifyRest',
        'change @ui.customWebpageEditItemRightContent_select_Font1_FontType': 'change_Font1_Type',
        'change @ui.customWebpageEditItemRightContent_select_Font2_FontType': 'change_Font2_Type',
        'change @ui.customWebpageEditItemRightContent_select_Font1_ColorType': 'change_Font1_ColorType',
        'change @ui.customWebpageEditItemRightContent_select_Font2_ColorType': 'change_Font2_ColorType',
        'change @ui.customWebpageEditItemRightContent_select_MenuColorApp_FontType': 'change_MenuColorApp_FontType_Type',
    },
    onRender: function () {
        this.setupFont();

        var checked = this.model.attributes.EnableWindowPage == 1 ? true : false;
        this.ui.customWebpageEditItemRightContent_checkbox_EnableWindowPage.attr('checked', checked);

        
        
    },
    onAttach() {
        var self = this;

        

        var fonts = [];

        self.app.entities.collections.Font.forEach(function (entry) {
            fonts.push(entry.attributes.data_font_family);
        });

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_BackGroundColorApp.colorpicker({
            color: self.model.attributes.AppFrame_BackGroundColorApp,
            format: "rgb"
        });
        var cp = this.ui.customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_BackGroundColorApp.colorpicker('colorpicker');
        cp.disable();

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_BackGroundColor.colorpicker({
            color: self.model.attributes.AppFrame_BackGroundColor,
            format: "rgb"
        });

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_ForeGroundColorApp.colorpicker({
            color: self.model.attributes.AppFrame_ForeGroundColorApp,
            format: "rgb"
        });
        var cp = this.ui.customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_ForeGroundColorApp.colorpicker('colorpicker');
        cp.disable();

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_AppFrame_ForeGroundColor.colorpicker({
            color: self.model.attributes.AppFrame_ForeGroundColor,
            format: "rgb"
        });

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_BackGroundColorApp.colorpicker({
            color: self.model.attributes.BackGroundColorApp,
            format: "rgb"
        });
        var cp = this.ui.customWebpageEditItemRightContent_ColorPickerSliders_BackGroundColorApp.colorpicker('colorpicker');
        cp.disable();

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_BackGroundColor.colorpicker({
            color: self.model.attributes.BackGroundColor,
            format: "rgb"
        });


        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_MenuColorApp_BackGround.colorpicker({
            color: self.model.attributes.MenuColorApp_BackGround,
            format: "rgb"
        });
        var cp = this.ui.customWebpageEditItemRightContent_ColorPickerSliders_MenuColorApp_BackGround.colorpicker('colorpicker');
        cp.disable();

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_MenuColor_BackGround.colorpicker({
            color: self.model.attributes.MenuColor_BackGround,
            format: "rgb"
        });

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_MenuColorApp_ForeGround.colorpicker({
            color: self.model.attributes.MenuColorApp_ForeGround,
            format: "rgb"
        });
        var cp = this.ui.customWebpageEditItemRightContent_ColorPickerSliders_MenuColorApp_ForeGround.colorpicker('colorpicker');
        cp.disable();

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_MenuColor_ForeGround.colorpicker({
            color: self.model.attributes.MenuColor_ForeGround,
            format: "rgb"
        });

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_Font1_ColorTheme.colorpicker({
            color: self.model.attributes.Font1_ColorTheme,
            format: "rgb"
        }).on('colorpickerHide', function (e) {
        });
        var cp = this.ui.customWebpageEditItemRightContent_ColorPickerSliders_Font1_ColorTheme.colorpicker('colorpicker');
        cp.disable();

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_Font1_ColorSelect.colorpicker({
            color: self.model.attributes.Font1_ColorSelect,
            format: "rgb"
        }).on('colorpickerHide', function (e) {
            self.updateAll(); 
        });

        //this.ui.customWebpageEditItemRightContent_ColorPickerSliders_Font1_Color.on('hidePicker', function () {
        //    alert("hide");
        //});
            

        this.ui.customWebpageEditItemRightContent_dropDown_Font1_Select.fontselect({
            googleFonts: fonts
        }).on('change', function () {
            self.model.attributes.Font1_Select = this.value;
            self.model.attributes.Font1 = this.value;
            self.model.trigger('change');
        });
        this.ui.customWebpageEditItemRightContent_dropDown_Font1_Select.trigger('setFont', self.model.attributes.Font1_Select);

        this.ui.customWebpageEditItemRightContent_dropDown_Font1_Theme.fontselect({
            googleFonts: fonts
        }).on('change', function () {
        });
        this.ui.customWebpageEditItemRightContent_dropDown_Font1_Theme.trigger('setFont', self.model.attributes.Font1_Theme);
        this.ui.customWebpageEditItemRightContent_formgroup_Font1_Theme.addClass('disabledFontSelect_FormGroup');
        this.ui.customWebpageEditItemRightContent_formgroup_Font1_Theme.find('.font-select').addClass('disabledFontSelect_FontSelect');

        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_Font2_ColorSelect.colorpicker({
            color: self.model.attributes.Font2_ColorSelect,
            format: "rgb"
        }).on('colorpickerHide', function (e) {
            self.updateAll();
        });
        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_Font2_ColorTheme.colorpicker({
            color: self.model.attributes.Font2_ColorTheme,
            format: "rgb"
        }).on('colorpickerHide', function (e) {
        });
        var cp = this.ui.customWebpageEditItemRightContent_ColorPickerSliders_Font2_ColorTheme.colorpicker('colorpicker');
        cp.disable();

        this.ui.customWebpageEditItemRightContent_dropDown_Font2_Select.fontselect({
            googleFonts: fonts
        }).on('change', function () {
            self.model.attributes.Font2_Select = this.value;
            self.model.attributes.Font2 = this.value;
            self.model.trigger('change');
        });
        this.ui.customWebpageEditItemRightContent_dropDown_Font2_Select.trigger('setFont', self.model.attributes.Font2_Select);

        this.ui.customWebpageEditItemRightContent_dropDown_Font2_Theme.fontselect({
            googleFonts: fonts
        }).on('change', function () {
        });
        this.ui.customWebpageEditItemRightContent_dropDown_Font2_Theme.trigger('setFont', self.model.attributes.Font2_Theme);
        this.ui.customWebpageEditItemRightContent_formgroup_Font2_Theme.addClass('disabledFontSelect_FormGroup');
        this.ui.customWebpageEditItemRightContent_formgroup_Font2_Theme.find('.font-select').addClass('disabledFontSelect_FontSelect');


        this.ui.customWebpageEditItemRightContent_ColorPickerSliders_Font3_Color.colorpicker({
            color: self.model.attributes.Font3_Color,
            format: "rgb"
        });

        this.ui.customWebpageEditItemRightContent_dropDown_Font3.fontselect({
            googleFonts: fonts
        }).on('change', function () {
            self.model.attributes.Font3 = this.value;
        });
        this.ui.customWebpageEditItemRightContent_dropDown_Font3.trigger('setFont', self.model.attributes.Font3);

        this.ui.customWebpageEditItemRightContent_dropDown_MenuColorApp_Font.fontselect({
            googleFonts: fonts
        }).on('change', function () {
            self.model.attributes.MenuColorApp_Font = this.value;
            self.model.trigger('change');
        });
        this.ui.customWebpageEditItemRightContent_dropDown_MenuColorApp_Font.trigger('setFont', self.model.attributes.MenuColorApp_Font);
        this.ui.customWebpageEditItemRightContent_formgroup_MenuColorApp_Font.addClass('disabledFontSelect_FormGroup');
        this.ui.customWebpageEditItemRightContent_formgroup_MenuColorApp_Font.find('.font-select').addClass('disabledFontSelect_FontSelect');

        this.ui.customWebpageEditItemRightContent_dropDown_MenuColor_Font.fontselect({
            googleFonts: fonts
        }).on('change', function () {
            self.model.attributes.MenuColor_Font = this.value;
            self.model.trigger('change');
        });
        this.ui.customWebpageEditItemRightContent_dropDown_MenuColor_Font.trigger('setFont', self.model.attributes.MenuColor_Font);


        //var width = this.ui.customWebpageEditItemRightContent_dropDown_Font1.css('width');
        $('.font-select').css('width', '100%');

        self.setupAppFrameBackGroundColorType();
        self.setupAppFrameForeGroundColorType();

        self.setupFontType();
        self.setupFontColorType();
        self.setupBackGroundType();
        self.setupMenuColorApp_BackGroundType();
        self.setupMenuColorApp_ForeGroundType();
        self.setupBackGroundImagePosition();
        self.setupFontSize();
        self.setupFontStyle();
        self.setupFontLineHeight();
        self.setupImage();

        FilePond.registerPlugin(
            FilePondPluginFileEncode,
            FilePondPluginImageCrop,
            FilePondPluginImageResize,
            FilePondPluginImageTransform,
            FilePondPluginImagePreview,
            FilePondPluginImageEdit,

        );

        var labelIdle = resources.X101490 + ' <span class="filepond--label-action">' + resources.X101437 + '</span>';

        var pond = FilePond.create(this.ui.customWebpageEditItemRightContent_filePond[0], {
            labelIdle: [
                labelIdle,
                ''
            ],
            allowMultiple: false,
            //allowReorder: true,
            //allowFileEncode: true,
            //allowImageCrop: true,
            //imageCropAspectRatio:"1:1",
            //allowImageResize: true,//Before
            //imageResizeTargetWidth: 750,//Before
            //imageResizeTargetHeight: 750,//Before
            imageResizeMode: 'contain',
            //imageResizeUpscale: true,//Before
            //imageCropAspectRatio: 1,
            allowImageTransform: true,
            //allowImagePreview: true,
            //allowImageEdit:true,

            onaddfile: (err, fileItem) => {
                if (err == null) {
                    //console.log(err, fileItem.getMetadata('resize'));
                    var base64 = fileItem.getFileEncodeDataURL();
                    //var base64 = fileItem.getFileEncodeBase64String();

                    var canvas = document.createElement('canvas');
                    canvas.width = 750;
                    canvas.height = 750;

                    var context = canvas.getContext('2d');

                    var image = new Image();
                    image.src = base64;

                    image.onload = function () {


                        var wrh = image.width / image.height;
                        var newWidth = canvas.width;
                        var newHeight = newWidth / wrh;
                        if (newHeight > canvas.height) {
                            newHeight = canvas.height;
                            newWidth = newHeight * wrh;
                        }
                        var xOffset = newWidth < canvas.width ? ((canvas.width - newWidth) / 2) : 0;
                        var yOffset = newHeight < canvas.height ? ((canvas.height - newHeight) / 2) : 0;

                        /* force original size */
                        newWidth = image.width;
                        newHeight = image.height;
                        xOffset = 0;
                        yOffset = 0;
                        canvas.width = image.width;
                        canvas.height = image.height;
                        /* force original size */

                        context.beginPath();
                        //context.fillStyle = "white";
                        //context.fillRect(0, 0, canvas.width, canvas.height);
                        context.drawImage(image, xOffset, yOffset, newWidth, newHeight);

                        base64 = canvas.toDataURL();

                        var tmpModel = new Entities_Memory_Position.Model();
                        tmpModel.attributes.Selected = true;

                        var searchString = ";base64,";
                        var pos = base64.indexOf(searchString);
                        var imageMime = base64.substring(5, pos);
                        var imageData = base64.substring(pos + searchString.length, base64.length);

                        var old_InfoImage_id = self.model.attributes.BackGroundImage_InfoImage_id;

                        var callbackSaveImage = function (model) {
                            self.model.attributes.BackGroundImage_InfoImage_id = model.attributes.id;
                            self.model.attributes.BackGroundImage_InfoImage_ImageUrl = model.attributes.ImageUrl;
                            self.model.attributes.BackGroundImage_InfoImage_Name = model.attributes.Name;

                            self.setupImage();

                            pond.removeFile(fileItem);

                            if (old_InfoImage_id != 0) {
                                var customInfoImageModel = self.app.entities.collections.customInfoImage.where({ id: old_InfoImage_id })[0];

                                customInfoImageModel.destroy({
                                    wait: true,
                                    success: function (model, response) {
                                    },
                                    error: function (model, response) {
                                    }
                                });
                            }
                        }

                        helper_image.saveImage(self, callbackSaveImage, imageData, imageMime, self.options.eventId, 0, '', '', 100);
                        //self.saveImage(callbackSaveImage, imageData, imageMime);

                    };
                }
            }
        });

        //customWebpageEditItemRightContent_ColorPickerSliders_Font1_Color

        $('#customWebpageEditItemListTop').find('.setcursor').css('cursor', 'pointer');
        $('#customWebpageEditItemListBottom').find('.setcursor').css('cursor', 'pointer');

        switch (this.model.attributes.Font1_FontType) {
            case "0":
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_Select.css('display', 'none');
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_Theme.show();
                break;
            case "10":
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_Select.show();
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_Theme.css('display', 'none');

                break;
        }

        switch (this.model.attributes.Font2_FontType) {
            case "0":
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_Select.css('display', 'none');
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_Theme.show();
                break;
            case "10":
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_Select.show();
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_Theme.css('display', 'none');
                break;
        }

        switch (this.model.attributes.Font1_ColorType) {
            case "0":
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_ColorSelect.css('display', 'none');
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_ColorTheme.show();
                break;
            case "10":
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_ColorSelect.show();
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_ColorTheme.css('display', 'none');
                break;
        }

        switch (this.model.attributes.Font2_ColorType) {
            case "0":
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_ColorSelect.css('display', 'none');
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_ColorTheme.show();
                break;
            case "10":
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_ColorSelect.show();
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_ColorTheme.css('display', 'none');
                break;
        }

        switch (this.model.attributes.MenuColorApp_FontType) {
            case "0":
                this.ui.customWebpageEditItemRightContent_formgroup_MenuColorApp_Font.show();
                this.ui.customWebpageEditItemRightContent_formgroup_MenuColor_Font.css('display', 'none');
                break;
            case "10":
                this.ui.customWebpageEditItemRightContent_formgroup_MenuColorApp_Font.css('display', 'none');
                this.ui.customWebpageEditItemRightContent_formgroup_MenuColor_Font.show();
                break;
        }
    },
    setupFontType: function () {
        var self = this;

        self.ui.customWebpageEditItemRightContent_select_Font1_FontType.empty();

        var selected = '';

        self.app.entities.collections.GridFontType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font1_FontType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_select_Font1_FontType.append(options);
        });

        self.ui.customWebpageEditItemRightContent_select_Font2_FontType.empty();

        var selected = '';

        self.app.entities.collections.GridFontType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font2_FontType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_select_Font2_FontType.append(options);
        });

        self.ui.customWebpageEditItemRightContent_select_MenuColorApp_FontType.empty();

        var selected = '';

        self.app.entities.collections.GridFontType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.MenuColorApp_FontType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_select_MenuColorApp_FontType.append(options);
        });
        
    },
    setupFontColorType: function () {
        var self = this;

        self.ui.customWebpageEditItemRightContent_select_Font1_ColorType.empty();
        self.ui.customWebpageEditItemRightContent_select_Font2_ColorType.empty();

        var selected = '';

        self.app.entities.collections.GridFontColorType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font1_ColorType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_select_Font1_ColorType.append(options);
        });

        self.app.entities.collections.GridFontColorType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font2_ColorType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_select_Font2_ColorType.append(options);
        });
    },
    setupBackGroundType: function () {
        var self = this;

        this.ui.customWebpageEditItemRightContent_select_BackGroundColorType.empty();

        var selected = '';

        self.app.entities.collections.AppBackGroundColorType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.BackGroundColorType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_select_BackGroundColorType.append(options);
        });
    },

    setupAppFrameBackGroundColorType: function () {
        var self = this;

        this.ui.customWebpageEditItemRightContent_select_AppFrame_BackGroundType.empty();

        var selected = '';

        self.app.entities.collections.AppFrame_BackGroundType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.AppFrame_BackGroundColorType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_select_AppFrame_BackGroundType.append(options);
        });
    },
    setupAppFrameForeGroundColorType: function () {
        var self = this;

        this.ui.customWebpageEditItemRightContent_select_AppFrame_ForeGroundType.empty();

        var selected = '';

        self.app.entities.collections.AppFrame_ForeGroundType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.AppFrame_ForeGroundColorType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_select_AppFrame_ForeGroundType.append(options);
        });
    },
    setupMenuColorApp_BackGroundType: function () {
        var self = this;

        this.ui.customWebpageEditItemRightContent_select_MenuColorApp_BackGroundType.empty();

        var selected = '';

        self.app.entities.collections.AppMenuColorBackGroundType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.MenuColorApp_BackGroundType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_select_MenuColorApp_BackGroundType.append(options);
        });

        /*var selected = '';

        if (self.model.attributes.BackGroundType == "0") {
            selected = 'selected = "selected"';
        }

        var options = String.format('<option {1} value="0">{0}</option>', resources.X101329, selected);
        this.ui.customWebpageEditItemRightContent_select_BGType.append(options);

        selected = '';

        if (self.model.attributes.BackGroundType == "1") {
            selected = 'selected = "selected"';
        }

        var options = String.format('<option {1} value="1">{0}</option>', resources.X101330, selected);
        this.ui.customWebpageEditItemRightContent_select_BGType.append(options);*/


    },
    setupMenuColorApp_ForeGroundType: function () {
        var self = this;

        this.ui.customWebpageEditItemRightContent_select_MenuColorApp_ForeGroundType.empty();

        var selected = '';

        self.app.entities.collections.AppMenuColorForeGroundType.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.MenuColorApp_ForeGroundType == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_select_MenuColorApp_ForeGroundType.append(options);
        });
    },
    setupBackGroundImagePosition: function () {
        var self = this;

        this.ui.customWebpageEditItemRightContent_dropDown_backGroundImagePosition.empty();

        var selected = '';

        self.app.entities.collections.ModuleBackGroundImagePosition.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.BackGroundImagePosition == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_dropDown_backGroundImagePosition.append(options);
        });
    },
    setupFontSize: function () {
        var self = this;

        this.ui.customWebpageEditItemRightContent_dropDown_Font_Size1.empty();
        this.ui.customWebpageEditItemRightContent_dropDown_Font_Size2.empty();
        //this.ui.customWebpageEditItemRightContent_dropDown_Font_Size3.empty();

        var selected = '';

        for (var i = 10; i <= 200; i++) {
            selected = '';

            if (self.model.attributes.Font1_Size == String.format('{0}{1}', i, 'px')) {
                selected = 'selected = "selected"';
            }

            var options = String.format('<option {1}>{0}px</option>', i, selected);
            this.ui.customWebpageEditItemRightContent_dropDown_Font_Size1.append(options);
        }
        for (var i = 10; i <= 200; i++) {
            selected = '';

            if (self.model.attributes.Font2_Size == String.format('{0}{1}', i, 'px')) {
                selected = 'selected = "selected"';
            }

            var options = String.format('<option {1}>{0}px</option>', i, selected);
            this.ui.customWebpageEditItemRightContent_dropDown_Font_Size2.append(options);
        }
        //for (var i = 10; i <= 200; i++) {
        //    selected = '';

        //    if (self.model.attributes.Font3_Size == String.format('{0}{1}', i, 'px')) {
        //        selected = 'selected = "selected"';
        //    }

        //    var options = String.format('<option {1}>{0}px</option>', i, selected);
        //    this.ui.customWebpageEditItemRightContent_dropDown_Font_Size3.append(options);
        //}
    },
    setupFontStyle: function () {
        var self = this;
        self.ui.customWebpageEditItemRightContent_dropDown_Font_Style1.empty();
        self.ui.customWebpageEditItemRightContent_dropDown_Font_Style2.empty();
        //self.ui.customWebpageEditItemRightContent_dropDown_Font_Style3.empty();

        var selected = '';

        self.app.entities.collections.FontStyle.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font1_Style == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_dropDown_Font_Style1.append(options);
        });
        self.app.entities.collections.FontStyle.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font2_Style == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_dropDown_Font_Style2.append(options);
        });
        /*self.app.entities.collections.FontStyle.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font3_Style == entry.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.Name, entry.Value, selected);
            self.ui.customWebpageEditItemRightContent_dropDown_Font_Style3.append(options);
        });*/

    },
    setupFontLineHeight: function () {
        var self = this;
        self.ui.customWebpageEditItemRightContent_dropDown_Font_LineHeight1.empty();
        self.ui.customWebpageEditItemRightContent_dropDown_Font_LineHeight2.empty();
        //self.ui.customWebpageEditItemRightContent_dropDown_Font_LineHeight3.empty();

        var selected = '';

        self.app.entities.collections.LineHeight.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font1_LineHeight == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_dropDown_Font_LineHeight1.append(options);
        });
        self.app.entities.collections.LineHeight.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font2_LineHeight == entry.attributes.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.Value, selected);
            self.ui.customWebpageEditItemRightContent_dropDown_Font_LineHeight2.append(options);
        });
        /*self.app.entities.collections.LineHeight.forEach(function (entry) {
            selected = '';
            if (self.model.attributes.Font3_LineHeight == entry.Value) {
                selected = 'selected = "selected"';
            }
            var options = String.format('<option value="{1}" {2}>{0}</option>', entry.Name, entry.Value, selected);
            self.ui.customWebpageEditItemRightContent_dropDown_Font_LineHeight3.append(options);
        });*/
    },
    setupImage: function () {
        if (this.model.attributes.BackGroundImage_InfoImage_ImageUrl != '') {
            this.ui.customWebpageEditItemRightContent_image_background.attr('src', this.model.attributes.BackGroundImage_InfoImage_ImageUrl);
        }
    },
    setupFont: function () {
        this.ui.customWebpageEditItemRightContent_dropDown_Font1_Select.empty();
        var self = this;
        var i = 0;
        self.app.entities.collections.Font.forEach(function (entry) {
            i++;

            if (i < 100) {
                var options = String.format("<option data-content=\"<span style=\"font-family:'{0}'\" class='text'>{1}</span>\">{1}</option>", entry.image, entry.data_font_family);
                self.ui.customWebpageEditItemRightContent_dropDown_Font1_Select.append(options);
            }
        });

        this.ui.customWebpageEditItemRightContent_dropDown_Font2_Select.empty();
        var self = this;
        var i = 0;
        self.app.entities.collections.Font.forEach(function (entry) {
            i++;

            if (i < 100) {
                var options = String.format("<option data-content=\"<span style=\"font-family:'{0}'\" class='text'>{1}</span>\">{1}</option>", entry.image, entry.data_font_family);
                self.ui.customWebpageEditItemRightContent_dropDown_Font2_Select.append(options);
            }
        });

        this.ui.customWebpageEditItemRightContent_dropDown_MenuColor_Font.empty();
        var self = this;
        var i = 0;
        self.app.entities.collections.Font.forEach(function (entry) {
            i++;

            if (i < 100) {
                var options = String.format("<option data-content=\"<span style=\"font-family:'{0}'\" class='text'>{1}</span>\">{1}</option>", entry.image, entry.data_font_family);
                self.ui.customWebpageEditItemRightContent_dropDown_MenuColor_Font.append(options);
            }
        });
    },
    colorChange_AppFrame_BackGroundColor: function (e) {
        this.model.attributes.AppFrame_BackGroundColor = e.value.toRgbString();
    },
    colorChange_AppFrame_ForeGroundColor: function (e) {
        this.model.attributes.AppFrame_ForeGroundColor = e.value.toRgbString();
    },
    colorChange_BackGroundColor: function (e) {
        //this.model.attributes.BackGroundColor = e.value.toRgbString();

        this.model.set({
            BackGroundColor: e.value.toRgbString()
        });
    },

    colorChange_MenuColor_BackGround: function (e) {
        this.model.set({
            MenuColor_BackGround: e.value.toRgbString()
        });
    },
    colorChange_MenuColor_ForeGround: function (e) {
        this.model.set({
            MenuColor_ForeGround: e.value.toRgbString()
        });
    },

    colorChange_MenuColor: function (e) {
        this.model.attributes.MenuColor = e.value.toRgbString();
    },
    colorChange_GridColor: function (e) {
        this.model.attributes.GridColor = e.value.toRgbString();
    },
    validateExt(filename) {
        var dotPosition = filename.lastIndexOf(".");
        if (dotPosition > 0) {
            var ext = filename.substring(dotPosition + 1, filename.length).toLowerCase();

            switch (ext) {
                case 'gif': return true; break;
                case 'jpg': return true; break;
                case 'png': return true; break;
                case 'bmp': return true; break;
                case 'tif': return true; break;
                case 'tiff': return true; break;
            }
        }

        return false;
    },
    //btnImageChange: function (event) {
    //    event.preventDefault();

    //    var self = this;

    //    //remove path
    //    var filename = event.target.value.split('\\').pop();

    //    if (this.validateExt(filename)) {

    //        //remove extension
    //        var dotPosition = filename.lastIndexOf(".");
    //        if (dotPosition > 0) {
    //            filename = filename.substring(0, dotPosition);
    //        }

    //        this.file = FileAPI.getFiles(event)[0];

    //        if (this.file) {


    //            if (this.file.size < 40000000) {

    //                var reader = new FileReader();
    //                reader.onload = function (e) {
    //                    self.ui.customWebpageEditItemRightContent_image_background.attr('src', e.target.result);

    //                    var callbackSaveImage = function (model) {
    //                        tmpModel.attributes.InfoImage_id = model.attributes.id;
    //                        tmpModel.attributes.InfoImage_ImageUrl = model.attributes.ImageUrl;
    //                        tmpModel.attributes.InfoImage_Name = model.attributes.Name;

    //                    }

    //                    //self.model.attributes.BackGroundImage_InfoImage_ImageUrl = e.target.result;

    //                    var searchString = ";base64,";
    //                    var pos = base64.indexOf(searchString);
    //                    var imageMime = base64.substring(5, pos);
    //                    var imageData = base64.substring(pos + searchString.length, base64.length);

    //                    self.saveImage(callbackSaveImage, e.target.result, imageMime);

    //                }
    //                reader.readAsDataURL(this.file);
    //            }
    //        }
    //    }
    //},
    saveImage: function (parent, callback, imageData, imageMime) {
        var nowLocalDate = new Date();

        var strLocalDate = nowLocalDate.getFullYear().toString() +
            helper_image.fillup((nowLocalDate.getMonth() + 1).toString()) +
            helper_image.fillup(nowLocalDate.getDate().toString()) +
            helper_image.fillup(nowLocalDate.getHours().toString()) +
            helper_image.fillup(nowLocalDate.getMinutes().toString()) +
            helper_image.fillup(nowLocalDate.getSeconds().toString()) +
            nowLocalDate.getMilliseconds().toString();


        var filename = strLocalDate + " - " + "Test";

        var tmpModel = new this.app.entities.collections.customInfoImage.model();
        tmpModel.attributes.AuthUserId = config.authUserId();
        tmpModel.attributes.Name = filename;
        tmpModel.attributes.ImageData = imageData;
        tmpModel.attributes.ImageMimeType = imageMime;
        tmpModel.attributes.ImageUpdate = true;

        tmpModel.attributes.EventId = this.options.eventId;
        tmpModel.attributes.TemplateId = 0;
        tmpModel.attributes.ModuleRegion = '';
        tmpModel.attributes.ModuleDiv = '';
        tmpModel.attributes.ModuleType = 100;

        tmpModel.attributes.Filename = filename + '.png';

        this.app.entities.collections.customInfoImage.create(tmpModel, {
            wait: true,
            success: function (response) {
                callback(response);
            }
        });

    },
    //btnImageDelete: function (event) {
    //    this.ui.customWebpageEditItemRightContent_image_background.attr('src', '');
    //    self.model.attributes.BackGroundImage_InfoImage_ImageUrl = "";
    //},
    colorChange_Font1ColorSelect: function (e) {
        if (typeof e.value === 'string') {
            this.model.attributes.Font1_ColorSelect = e.value;
        }
        else {
            this.model.attributes.Font1_ColorSelect = e.value.toRgbString();
        }

        if (this.model.attributes.Font1_ColorType == "10") {
            this.model.attributes.Font1_Color = this.model.attributes.Font1_ColorSelect;
        }
        //this.updateAll();
    },
    colorChange_Font2ColorSelect: function (e) {
        if (typeof e.value === 'string') {
            this.model.attributes.Font2_ColorSelect = e.value;
        }
        else {
            this.model.attributes.Font2_ColorSelect = e.value.toRgbString();
        }

        if (this.model.attributes.Font2_ColorType == "10") {
            this.model.attributes.Font2_Color = this.model.attributes.Font2_ColorSelect;
        }
        //this.updateAll();
    },
    modifyRest: function () {
        this.model.attributes.BackGroundColorType = this.ui.customWebpageEditItemRightContent_select_BackGroundColorType.val();
        this.model.attributes.MenuColorApp_BackGroundType = this.ui.customWebpageEditItemRightContent_select_MenuColorApp_BackGroundType.val();
        this.model.attributes.MenuColorApp_ForeGroundType = this.ui.customWebpageEditItemRightContent_select_MenuColorApp_ForeGroundType.val();

        this.model.attributes.AppFrame_BackGroundColorType = this.ui.customWebpageEditItemRightContent_select_AppFrame_BackGroundType.val();
        this.model.attributes.AppFrame_ForeGroundColorType = this.ui.customWebpageEditItemRightContent_select_AppFrame_ForeGroundType.val();

        this.model.attributes.Font1_Size = this.ui.customWebpageEditItemRightContent_dropDown_Font_Size1.val();
        this.model.attributes.Font2_Size = this.ui.customWebpageEditItemRightContent_dropDown_Font_Size2.val();

        this.model.attributes.Font1_LineHeight = this.ui.customWebpageEditItemRightContent_dropDown_Font_LineHeight1.val();
        this.model.attributes.Font2_LineHeight = this.ui.customWebpageEditItemRightContent_dropDown_Font_LineHeight2.val();

        this.model.attributes.Font1_Style = this.ui.customWebpageEditItemRightContent_dropDown_Font_Style1.val();
        this.model.attributes.Font2_Style = this.ui.customWebpageEditItemRightContent_dropDown_Font_Style2.val();

        this.model.attributes.BackGroundImagePosition = this.ui.customWebpageEditItemRightContent_dropDown_backGroundImagePosition.val();

        var EnableWindowPage = this.model.attributes.EnableWindowPage;
        this.ui.customWebpageEditItemRightContent_checkbox_EnableWindowPage.is(':checked') ? EnableWindowPage = 1 : EnableWindowPage = 0;
        this.model.attributes.EnableWindowPage = EnableWindowPage;

        this.model.trigger('change');
    },
    updateAll: function () {
        this.modifyRest();
        /*this.model.trigger('change');

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('InfoPageSetting:change');*/
    },
    col_01_click: function () {
        this.col_MenuSingle(1);
        /*var self = this;

        var menuItemCollection = new Entities_Memory_Position.Collection(this.model.attributes.Collection);

        var tmpModel = menuItemCollection.where({ Position: 1 })[0];
        var tmpCollection = new Entities_Memory_Position.Collection(tmpModel.attributes.Collection);

        var menuSingle = new View_MenuSingle({ app: this.app, model: tmpModel, parent: self, collection: tmpCollection, eventId : this.options.eventId, menuItemCollection : this.collection });

        var callback01 = function (options) {
            self.stopListening(menuSingle, "dialog:btn01clicked", callback01);
            self.stopListening(menuSingle, "dialog:btn02clicked", callback02);

            menuItemCollection.where({ Position: 1 })[0].attributes = menuSingle.model.attributes;
            menuItemCollection.where({ Position: 1 })[0].attributes.Collection = menuSingle.collection.toJSON();

            self.model.attributes.Collection = menuItemCollection.toJSON();
            self.model.trigger('change');
       }
        self.listenTo(menuSingle, "dialog:btn01clicked", callback01);

        var callback02 = function (options) {
            self.stopListening(menuSingle, "dialog:btn01clicked", callback01);
            self.stopListening(menuSingle, "dialog:btn02clicked", callback02);
        }
        self.listenTo(menuSingle, "dialog:btn02clicked", callback02);

        self.app.dialogRegion.show(menuSingle);*/
    },
    col_02_click: function () {
        this.col_MenuSingle(2);
    },
    col_03_click: function () {
        this.col_MenuSingle(3);
    },
    col_04_click: function () {
        this.col_MenuSingle(4);
    },
    col_05_click: function () {
        this.col_MenuSingle(5);
    },
    col_06_click: function () {
        this.col_MenuSingle(6);
    },
    col_07_click: function () {
        this.col_MenuSingle(7);
    },
    col_08_click: function () {
        this.col_MenuSingle(8);
    },
    col_09_click: function () {
        this.col_MenuSingle(9);
    },
    col_10_click: function () {
        this.col_MenuSingle(10);
    },
    col_11_click: function () {
        this.col_MenuSingle(11);
    },
    col_12_click: function () {
        this.col_MenuSingle(12);
    },
    col_MenuSingle: function(position) {
        var self = this;

        var menuItemCollection = new Entities_Memory_Position.Collection(this.model.attributes.Collection);

        var tmpModel = menuItemCollection.where({ Position: position })[0];
        var tmpCollection = new Entities_Memory_Position.Collection(tmpModel.attributes.Collection);

        var menuSingle = new View_MenuSingle({ app: this.app, model: tmpModel, parent: self, collection: tmpCollection, eventId: this.options.eventId, menuItemCollection: this.collection });

        var callback01 = function (options) {
            self.stopListening(menuSingle, "dialog:btn01clicked", callback01);
            self.stopListening(menuSingle, "dialog:btn02clicked", callback02);

            menuItemCollection.where({ Position: position })[0].attributes = menuSingle.model.attributes;
            menuItemCollection.where({ Position: position })[0].attributes.Collection = menuSingle.collection.toJSON();

            self.model.attributes.Collection = menuItemCollection.toJSON();
            self.model.trigger('change');
        }
        self.listenTo(menuSingle, "dialog:btn01clicked", callback01);

        var callback02 = function (options) {
            self.stopListening(menuSingle, "dialog:btn01clicked", callback01);
            self.stopListening(menuSingle, "dialog:btn02clicked", callback02);
        }
        self.listenTo(menuSingle, "dialog:btn02clicked", callback02);

        self.app.dialogRegion.show(menuSingle);
    },
    col_01_clickOld: function () {
        var self = this;

        var selectedModel = 1;
        var tmpModel = new Entities_Empty.Model();
        //var tmpCollection = new Entities_Memory_Position.Collection(this.model.attributes.Data.Collection);

        tmpModel.attributes.GridMenuType = "0";
        tmpModel.attributes.MenuItem = 7111;
        tmpModel.attributes.FontAwesome = 'fas fa-align-center';
            

        var gridMenu = new View_GridMenu({ app: this.app, model: tmpModel, parent: self, collection: this.collection });

        var callback01 = function (options) {
            self.stopListening(pictureSingle, "dialog:btn01clicked", callback01);
            self.stopListening(pictureSingle, "dialog:btn02clicked", callback02);

            self.model.attributes.Data = pictureSingle.model.toJSON();
            self.model.attributes.Data.Collection = pictureSingle.collection.toJSON();
            self.model.trigger('change');
        }
        self.listenTo(gridMenu, "dialog:btn01clicked", callback01);

        var callback02 = function (options) {
            self.stopListening(pictureSingle, "dialog:btn01clicked", callback01);
            self.stopListening(pictureSingle, "dialog:btn02clicked", callback02);
        }
        self.listenTo(gridMenu, "dialog:btn02clicked", callback02);

        self.app.dialogRegion.show(gridMenu);
    },
    change_MenuColorApp_FontType_Type: function () { 
        this.model.attributes.MenuColorApp_FontType = this.ui.customWebpageEditItemRightContent_select_MenuColorApp_FontType.val();

        switch (this.model.attributes.MenuColorApp_FontType) {
            case "0":
                this.ui.customWebpageEditItemRightContent_formgroup_MenuColorApp_Font.show();
                this.ui.customWebpageEditItemRightContent_formgroup_MenuColor_Font.css('display', 'none');
                break;
            case "10":
                this.ui.customWebpageEditItemRightContent_formgroup_MenuColorApp_Font.css('display', 'none'); 
                this.ui.customWebpageEditItemRightContent_formgroup_MenuColor_Font.show();
                break;
        }

        this.model.trigger('change');
    },
    change_Font1_Type: function () {
        this.model.attributes.Font1_FontType = this.ui.customWebpageEditItemRightContent_select_Font1_FontType.val();

        switch (this.model.attributes.Font1_FontType) {
            case "0": 
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_Select.css('display', 'none');
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_Theme.show();
                this.model.attributes.Font1 = this.model.attributes.Font1_Theme;
                break;
            case "10":
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_Select.show();
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_Theme.css('display', 'none');
                this.model.attributes.Font1 = this.model.attributes.Font1_Select;
                break;
        }

        this.model.trigger('change');
    },
    change_Font2_Type: function () {
        this.model.attributes.Font2_FontType = this.ui.customWebpageEditItemRightContent_select_Font2_FontType.val();

        switch (this.model.attributes.Font2_FontType) {
            case "0":
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_Select.css('display', 'none');
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_Theme.show();
                this.model.attributes.Font2 = this.model.attributes.Font2_Theme;
                break;
            case "10":
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_Select.show();
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_Theme.css('display', 'none');
                this.model.attributes.Font2 = this.model.attributes.Font2_Select;
                break;
        }

        this.model.trigger('change');
    },
    change_Font1_ColorType: function () {
        this.model.attributes.Font1_ColorType = this.ui.customWebpageEditItemRightContent_select_Font1_ColorType.val();

        switch (this.model.attributes.Font1_ColorType) {
            case "0":
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_ColorSelect.css('display', 'none');
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_ColorTheme.show();
                this.model.attributes.Font1_Color = this.model.attributes.Font1_ColorTheme;
                break;
            case "10":
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_ColorSelect.show();
                this.ui.customWebpageEditItemRightContent_formgroup_Font1_ColorTheme.css('display', 'none');
                this.model.attributes.Font1_Color = this.model.attributes.Font1_ColorSelect;
                break;
        }

        this.model.trigger('change');
    },
    change_Font2_ColorType: function () {
        this.model.attributes.Font2_ColorType = this.ui.customWebpageEditItemRightContent_select_Font2_ColorType.val();

        switch (this.model.attributes.Font2_ColorType) {
            case "0":
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_ColorSelect.css('display', 'none');
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_ColorTheme.show();
                this.model.attributes.Font2_Color = this.model.attributes.Font2_ColorTheme;
                break;
            case "10":
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_ColorSelect.show();
                this.ui.customWebpageEditItemRightContent_formgroup_Font2_ColorTheme.css('display', 'none');
                this.model.attributes.Font2_Color = this.model.attributes.Font2_ColorSelect;
                break;
        }

        this.model.trigger('change');
    },
}, Backbone.Radio.Requests);
